"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWrapped = exports.createFulfilledWrapped = exports.createRejectedWrapped = exports.pendingWrapped = void 0;
const rxjs_1 = require("rxjs");
const wrapped = "___wrapped___";
const symbol = Symbol.for(wrapped);
exports.pendingWrapped = { status: "pending", [wrapped]: symbol };
function createRejectedWrapped(error, reload = rxjs_1.noop) {
    return {
        status: "rejected",
        error,
        reload,
        [wrapped]: symbol,
    };
}
exports.createRejectedWrapped = createRejectedWrapped;
function createFulfilledWrapped(value) {
    return {
        status: "fulfilled",
        value,
        [wrapped]: symbol,
    };
}
exports.createFulfilledWrapped = createFulfilledWrapped;
function isWrapped(value) {
    return value && value[wrapped] === symbol;
}
exports.isWrapped = isWrapped;
